module.exports = __webpack_public_path__ + "static/mollton-light-4375428ccdb7446e5de83b873df4fc92.png";